export type ConfirmationTranslate = (key: string, options?: { defaultValue: string }) => string;

const COPY_ROOT = 'aiInsights.mutationConfirmation';

export const translateFieldLabel = (t: ConfirmationTranslate, tool: string, name: string, fallback: string): string =>
  t(`${COPY_ROOT}.fieldLabels.${tool}.${name}`, { defaultValue: fallback });

export const translateWarning = (t: ConfirmationTranslate, tool: string, fallback: string): string =>
  t(`${COPY_ROOT}.warnings.${tool}`, { defaultValue: fallback });

export const translateSummary = (t: ConfirmationTranslate, tool: string, fallback: string): string =>
  t(`${COPY_ROOT}.toolTitles.${tool}`, { defaultValue: fallback });

// The product's existing copy for enum values a tool input can take, keyed by enum name, then value
const ENUM_OPTION_LABEL_KEYS: Record<string, Record<string, string>> = {
  PixelMatchingCadence: {
    TwentyFourHours: 'audience.settings.pixelMatchingCadenceTwentyFourHours',
    FourHours: 'audience.settings.pixelMatchingCadenceFourHours',
  },
  AudienceQuotaPeriod: {
    Weekly: 'audience.settings.quotaTimeRange.weekly',
    Monthly: 'audience.settings.quotaTimeRange.monthly',
  },
};

/** An enum value's label in the viewer's language, or the value itself when the product has no copy for it. */
export const translateEnumOption = (t: ConfirmationTranslate, enumName: string, value: string): string => {
  const key = ENUM_OPTION_LABEL_KEYS[enumName]?.[value];
  return key ? t(key, { defaultValue: value }) : value;
};
